// This file loads necessary polyfills for older browsers
// It should be loaded before any other webpack entrypoints

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import 'raf/polyfill';
import 'whatwg-fetch';
// https://zengabor.github.io/zenscroll/
// This enables CSS scroll-behavior for Safari and more.
import 'zenscroll';

// IE11 does not natively support "new Event()"
// This polyfill adds support for "new CustomEvent()", which we should use instead of "new Event()"
// MDN source: https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
// Slightly tweaked to staisfy our linter.
(function() {
  if (typeof window.CustomEvent === 'function') return false;

  function CustomEvent(event, params) {
    const newParams = params || { bubbles: false, cancelable: false, detail: null };
    const evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, newParams.bubbles, newParams.cancelable, newParams.detail);
    return evt;
  }

  window.CustomEvent = CustomEvent;
  return 0;
})();

// Polyfill for the `closest` function.
// https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}
if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    let el = this;
    do {
      if (el.matches(s)) {
        return el;
      }
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}
